module.exports = __webpack_public_path__ + "img/chuva.8fcfabb4.svg";